import { action } from 'satcheljs';
import { ComposeViewState } from 'owa-mail-compose-store';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';

export default action(
    'onRemoveRecipientFromMailTip',
    (viewState: ComposeViewState, recipients: EmailAddressWrapper[]) => ({
        viewState,
        recipients,
    })
);
